export default class YearToday {
    private static readonly BASE_YEAR = 2016;
    private static intervalId: number | null = null;

    static init(): void {
        if (!document.querySelector('.js-year-today')) {
            return;
        }

        this.updateYearSpans();

        // Aktualizovat každou minutu (pro případ změny roku o půlnoci)
        this.intervalId = window.setInterval(() => {
            this.updateYearSpans();
        }, 60000);
    }

    private static calculateCustomYear(): number {
        const currentCalendarYear = new Date().getFullYear();
        return currentCalendarYear - this.BASE_YEAR + 1;
    }

    private static updateYearSpans(): void {
        const yearSpans = document.querySelectorAll('.js-year-today');
        const customYear = this.calculateCustomYear();

        yearSpans.forEach((span: Element) => {
            if (span instanceof HTMLElement) {
                span.textContent = customYear.toString();
            }
        });
    }

    // Volitelná metoda pro vyčištění intervalu
    static cleanup(): void {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
}
